import { startOfWeek, isBefore, parseISO } from 'date-fns';

/**
 * Check if a week is editable (current and future weeks only)
 * @param {Date|string} weekStartDate - The start date of the week to check
 * @returns {boolean} True if the week is editable (current or future week)
 */
export const isWeekEditable = (weekStartDate) => {
  try {
    const dateToCheck = typeof weekStartDate === 'string' ? parseISO(weekStartDate) : weekStartDate;
    const weekStart = startOfWeek(dateToCheck, { weekStartsOn: 1 });
    const currentWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
    // Week is editable if it is the current week or later
    return !isBefore(weekStart, currentWeekStart);
  } catch (error) {
    console.error('Error checking week editability:', error);
    return false; // Default to not editable on error
  }
};